module.exports = __webpack_public_path__ + "img/qr-download.ec5153ff.jpg";